import keyService, * as chord from "data/key"
import { CloseIcon } from 'images/icons/general'
import _ from 'lodash'
import React, { FC, useCallback, useEffect, useState } from 'react'
import { Svg_s } from 'styles/app-styles'
import { ModalContent_s, ModalTitle_s, Modal_s } from './modal-styles'

interface Props {
  canMove?: string,
  divStyle?: object,
  height?: number,
  show: boolean,
  title?: string,
  toggleShow: any,
  updateCoords?: Function,
  width?: number,
  closeIconWidth?: number
}

const Modal: FC<Props> = (props) => {
  const [moving, setMoving] = useState<boolean>(false);

  useEffect(() => {
    const keySubscription = keyService.stream().subscribe(k => {
      if (k.chord === chord.ESC) props.toggleShow(false)
    })

    return function cleanup() {
      keySubscription.unsubscribe()
    }
  }, [])

  const mouseDown = (e:MouseEvent) => {
    setMoving(true);
  }

  const mouseUp = useCallback(e => {
    if (moving) {
      setMoving(false);
    }
  }, [moving]);

  function isSummaryVisible() {
    const summaryBar = document.getElementById('summaryBar')
    return _.get(summaryBar, 'open')
  }

  const moveCarousel = useCallback(e => {
    e.preventDefault()
    if (moving) {
      const carouselModal = _.get(document.getElementById(props.canMove!), 'children.0');
      if (!carouselModal) return setMoving(false);
      const box = carouselModal.getBoundingClientRect();

      // Define minimum and maximum x and y positions
      const minX = 90;
      const maxX = window.innerWidth - box.width;
      const minY = isSummaryVisible() ? 205 : 155;
      const maxY = window.innerHeight - box.height;

      // Calculate new x and y positions
      let newX = box.left + e.movementX;
      let newY = box.top + e.movementY;

      // Clamp x and y positions to stay within the container's bounds
      newX = Math.max(minX, Math.min(newX, maxX));
      newY = Math.max(minY, Math.min(newY, maxY));

      // Apply the new positions
      carouselModal.style.left = `${newX}px`;
      carouselModal.style.top = `${newY}px`;

      // Optionally update coordinates in props
      props.updateCoords && props.updateCoords(newX, newY);
    }
  }, [moving]);

  useEffect(() => {
    window.onmouseup = mouseUp;
    window.onmousemove = moveCarousel;
  }, [mouseUp, moveCarousel]);

  let titleProps = {}
  if (props.canMove !== undefined){
    titleProps['onMouseDown'] = mouseDown
  }

  if (props.closeIconWidth !== undefined){
    titleProps['closeIconWidth'] = props.closeIconWidth
  }


  return (
    <Modal_s
      {...props}
      id={props.canMove || undefined}
    >
      <div style={props.divStyle}>
        <ModalTitle_s
          {...titleProps}
          title=""
        >
          {props.title}
          <a title="Close Dialog" onClick={e => {
            // prevent X icon click from tiggering table-automation clickSync
            // because that function will always fail the "carousel_in_focus" check
            // since the carousel will be closed by the time this event bubbles up
            e.stopPropagation()
            e.nativeEvent.stopImmediatePropagation()
            props.toggleShow(false)
          }}><Svg_s src={CloseIcon} /></a>
        </ModalTitle_s>
        <ModalContent_s>
          { props.children }
        </ModalContent_s>
      </div>
    </Modal_s>
  )
}

export default Modal
